import React from 'react';
import { Route, Switch } from 'react-router-dom';
import NavWithBackButton from './nav-with-back-button';
import NavWithLogo from './nav-with-logo';

import './head-nav-style.css';

function HeadNav() {
  return (
    <Switch>
      <Route exact path={'/direct'} component={NavWithBackButton} />
      <Route path={'/post'} component={NavWithBackButton} />
      <Route exact path={'*'} component={NavWithLogo} />
    </Switch>
  );
}

export default HeadNav;
